export default __webpack_public_path__ + "static/media/business-man.ecf70d7f.svg";